import { useQuery } from "@tanstack/react-query";
import { api } from "../api";

export interface TrafficBreakdownBucket {
  date: string;
  total: number;
  categories?: Record<string, number>;
  [key: string]: unknown;
}

export interface TrafficBreakdownResponse {
  buckets: TrafficBreakdownBucket[];
  granularity: string;
  [key: string]: unknown;
}

export function useTrafficBreakdown(
  userId: string,
  startDate: string,
  endDate: string,
  granularity?: string,
) {
  return useQuery<TrafficBreakdownResponse>({
    queryKey: ["marketing-traffic-breakdown", userId, startDate, endDate, granularity],
    queryFn: () =>
      api.marketing.trafficBreakdown.get(userId, { startDate, endDate, granularity }) as Promise<TrafficBreakdownResponse>,
    enabled: !!userId && !!startDate && !!endDate,
    staleTime: 60_000,
  });
}
